import React from 'react';
import PropTypes from 'prop-types';
import { Space } from '@pitchero/react-ui';
import Article from '../article';
import { Trans, withTranslation } from '../../lib/i18n';

const MatchPreview = ({ author, html, shareProps, published, t }) => (
  <Space bottom="large" component="div">
    <Article
      noImage
      title={t('teams:match_preview_title')}
      author={html && author ? author : null}
      published={published}
      shareProps={shareProps}
    >
      {html ? (
        <div className="bbcode-content" dangerouslySetInnerHTML={{ __html: html }} />
      ) : (
        <Trans i18nKey="teams:match_preview_placeholder">
          Sorry, a match preview hasn’t been added yet.
        </Trans>
      )}
    </Article>
  </Space>
);

MatchPreview.defaultProps = {
  author: null,
  html: null,
  shareProps: null,
  published: null,
};

MatchPreview.propTypes = {
  author: PropTypes.shape(),
  html: PropTypes.string,
  shareProps: PropTypes.shape(),
  published: PropTypes.string,
  t: PropTypes.func.isRequired,
};

export default withTranslation(['teams'])(MatchPreview);
